"use strict";
/**
 * @module Util.Check
 *
 * @brief Utility functions for checking arguments
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Throw an error if the checked value is null/undefined.
 *
 * @param value the value to check
 * @param what  description to include in thrown error
 * @returns     the checked value
 * @throws      an error if value is null or undefined
 */
function requireNonNull(value, what) {
    if (value === undefined || value === null) {
        throw new Error(what + ' is null');
    }
    return value;
}
exports.requireNonNull = requireNonNull;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/util/require-non-null.js
// module id = 28
// module chunks = 1